import axios from 'axios'
import { Toast } from 'vant';

import 'vant/lib/index.css';
import {
    DEV,
    PRODUCT
} from '@/utils/const'

// console.log("aaa", process.env)
const http = axios.create({
        method: 'post',
        timeout: 600000, // 
        headers: {},

        // jsonp: "callback", //Jquery生成验证参数的名称
        // dataType: "jsonp", //数据格式设置为jsonp
        baseURL: process.env.isDev ? DEV : PRODUCT,
        transformRequest: [function(data, headers) {
            return data;
        }],
        transformResponse: [function(data) {
            return data;
        }],

    })
    ///proxyApi
http.interceptors.request.use((config) => {
    // config.baseURL = sessionStorage.getItem("shopUrl") ? sessionStorage.getItem("shopUrl") : (process.env.isDev ? DEV : PRODUCT);
    return config
}, (err) => {
    return Promise.reject(err)
})

http.interceptors.response.use((data) => {
    // console.log("=====data===", data)
    let result;
    let res = JSON.parse(data.data)
    if (res.code == 0) {
        result = res.data
        return result
    } else {
        // Toast(res.msg)
    }
}, (err) => {
    Promise.reject(err)
})
export default http


// WEBPACK FOOTER //
// ./src/api/base.js